import React, { useState } from 'react'
import { Button, Space } from 'antd'
import { FilterOutlined, UpOutlined, DownOutlined } from '@ant-design/icons'
import FlexibleSearchForm from './JobBoardSearchForm'
import { initialFields, advancedFields } from '.'

const useStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    basicFilters: {
        marginBottom: '16px',
    },
    advancedFilters: {
        marginTop: '16px',
        borderTop: '1px solid #f0f0f0',
        paddingTop: '16px',
    },
    toggleButton: {
        width: '100%',
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
}

const SearchFilters = ({
    searchParams,
    onSubmit,
    isInSidebar = false,
    onAdvancedModalOpen
}) => {
    const [showAdvanced, setShowAdvanced] = useState(false)

    const handleSubmit = (values) => {
        onSubmit(values)
    }

    const renderBasicFilters = () => (
        <div style={useStyles.basicFilters}>
            <FlexibleSearchForm
                fields={initialFields}
                initialValues={searchParams}
                onSubmit={handleSubmit}
                columns={1}
                formLayout={isInSidebar ? "vertical" : "horizontal"}
            />
        </div>
    )

    const renderAdvancedFilters = () => (
        <div style={useStyles.advancedFilters}>
            <FlexibleSearchForm
                fields={advancedFields}
                initialValues={searchParams}
                onSubmit={handleSubmit}
                columns={1}
                formLayout="vertical"
            />
        </div>
    )

    if (isInSidebar) {
        return (
            <div style={useStyles.container}>
                {renderBasicFilters()}
                <Button
                    type="text"
                    style={useStyles.toggleButton}
                    onClick={() => setShowAdvanced(!showAdvanced)}
                    icon={showAdvanced ? <UpOutlined /> : <DownOutlined />}
                >
                    {showAdvanced ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
                </Button>
                {showAdvanced && renderAdvancedFilters()}
            </div>
        )
    }

    return (
        <div style={useStyles.container}>
            {renderBasicFilters()}
            <Button
                type="primary"
                icon={<FilterOutlined />}
                onClick={onAdvancedModalOpen}
            >
                Advanced Search Options
            </Button>
        </div>
    )
}

export default SearchFilters 